var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhiteVoteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5181 13.5701L17.52 13.573C17.6918 13.8379 17.9437 14.0543 18.2505 14.1794L18.3853 14.2273C18.7089 14.326 19.0522 14.316 19.3657 14.2039L19.4985 14.1501L19.5093 14.1443L24.3237 11.8503L21.187 23.3708H6.09229L2.95459 11.8503L7.77002 14.1443V14.1453L7.7749 14.1472C8.12365 14.3116 8.52257 14.3421 8.89502 14.2283C9.2652 14.115 9.56667 13.8727 9.76221 13.5671L9.76123 13.5662L13.6392 7.54858L17.5181 13.5701Z",
    stroke: "white",
    strokeWidth: 2.48
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteVoteIcon);
export default __webpack_public_path__ + "static/media/whiteVoteIcon.c263024afbdb52d790a15ee570e2554e.svg";
export { ForwardRef as ReactComponent };